
let dragTarget = {}; // {email}
let dragContainer = {}; // {group:{id}, name}

export function setDragging({user, container}) {
    dragTarget = user;
    dragContainer = container;
}

/**
 * 
 * @param {object} container {group: {id}, name}
 * @returns 
 */
export function canMoveTo(container) {
  try {
    return (dragContainer.group.id + dragContainer.name) !== (container.group.id + container.name)
  } catch(ex) {
    return false
  }
}

let moveToCb = (dragTarget, dragContainer, container) => {
  console.log(dragTarget, dragContainer.name, "->", container.name)
  // dispatch(editUser({id: dragTarget.id, changes: {thanhPhan: container.name}}))
};
export function setMoveToCb(cb) {
  moveToCb = cb;
}

/**
 * 
 * @param {object} container {group: {id}, name}
 * @param {*} dispatch 
 */
export function moveTo(container, dispatch) {
  moveToCb(dragTarget, dragContainer, container);
}

export function Overlay({ color }) {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        zIndex: 1,
        opacity: 0.5,
        backgroundColor: color,
      }}
    />
  );
}